/*global angular */
'use strict';

angular
  .module('MrDWebApp')
  .controller('CheckoutCtrl', function ($scope, $cookies, $location, storage, $http, $filter, order, orderFactory, userFactory, $state, $previousState, $rootScope, $window, $timeout, ebucks) {

    var _checkout = this;

    $window.scroll(0, 0);

    $scope._rc.track('checkout','view_order_review_screen');

    $scope._rc.bodyClass = 'html-checkout';

    _checkout.isWorking = false;

    _checkout.firebaseEvent = function (e, obj) { // must be declared before any events in $scope functions

      if (e === 'tap_continue_to_payment') {
        if (!obj.wicode)            delete obj.wicode;
        if (!obj.promo_code)        delete obj.promo_code;
        if (!obj.wicode_value)      delete obj.wicode_value;
        if (!obj.promo_code_value)  delete obj.promo_code_value;
        if (!obj.loyalty_type)      delete obj.loyalty_type;
        if (!obj.loyalty_status)    delete obj.loyalty_status;
      }

      if (window.firebase_an) {
        // console.log(`firebase: ${e}`, obj);
        window.firebase_an.logEvent(e, obj);
      }
    };

    // EFT Testing
    // _checkout.eft_testing = $location
    //   .search()
    //   .search()
    //   .eft;

    _checkout.credit_eft_cash_label = 'Continue to Payment';

    //$scope.showDiscountCodes = true; //TEST - DELETE FOR PRODUCTION
    $scope.coupon = {
      value: null,
      success: false,
      error: false,
      busy: false
    };
    $scope.voucher = {
      value: null,
      success: false,
      error: false,
      busy: false
    };

    _checkout.coupon_code = '';
    _checkout.couponError = false;
    _checkout.couponErrorMessage = '';
    _checkout.couponLoading = false;
    _checkout.ready = false;
    _checkout.ready_reason = 'Please report this error. Thanks.';

    if ($scope._rc.cart.restaurant.donation) {
      $scope._rc.variables.restaurant_donation = $scope._rc.cart.restaurant.donation;
      $scope.showRestaurantDonations = true;
    } else if (window.config.loaded) {
      $scope.showRestaurantDonations = window.config.show_restaurant_donation || false;
      $scope._rc.variables.restaurant_donation = $scope.showRestaurantDonations? window.config.default_restaurant_donation || 0 : 0;
      storage.set('mrd-web-variables', $scope._rc.variables);
    } else {
      $scope._rc.variables.restaurant_donation = 0;
      window.addEventListener('remote-config-loaded', function() {
        $rootScope.$apply(function () {
          $scope.showRestaurantDonations = window.config.show_restaurant_donation || false;
          $scope._rc.variables.restaurant_donation = $scope.showRestaurantDonations? window.config.default_restaurant_donation || 0 : 0;
          storage.set('mrd-web-variables', $scope._rc.variables);
        });
      });
    }

    var handledLoyaltyPrograms = ['ebucks']; //loyalty programs understood by UI
    _checkout.loyaltyPrograms = $scope._rc.variables.restaurant.loyalty_programs;
    //console.log('_checkout.loyaltyPrograms',_checkout.loyaltyPrograms);
    _checkout.loyaltyPrograms = _checkout.loyaltyPrograms.filter(function(lp){
      return ~handledLoyaltyPrograms.indexOf(lp.type) && lp.status !== 'hidden';
    });
    _checkout.showLoyaltyPrograms = _checkout.loyaltyPrograms.length > 0;
    var ebucksLoyalty = _checkout.loyaltyPrograms.find(function(lp){ return lp.type==='ebucks';});

    //#########################################################
    //  WiGroup Loyalty (Kauai)
    //#########################################################

    _checkout.wigroup = {
      earn: false,
      loadingValid: false,
      valid: null,
      phoneNumber: $scope._rc.access.lastWigroupNumber || '',
      error: null
    };

    // saved number from local storage
    if ($scope._rc.access.lastWigroupNumber && $scope._rc.access.lastWigroupNumber.length > 0) {
      _checkout.wigroup.earn = true;
      _checkout.wigroup.valid = true;
    }

    _checkout.maskOptions = {
      clearOnBlur: false
    };

    // ui-mask definitions. min 1, max 64 (? is used for optional character right after)
    _checkout.onlyNumbers = '9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?';
    _checkout.onlyNumbersLetters = '*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?*?';

    _checkout.removeLeadingZero = function (phoneNum) {
      if (phoneNum && phoneNum[0] === '0' && phoneNum.length === 10) {
        return phoneNum.substring(1);
      } else if (phoneNum) {
        return phoneNum;
      } else {
        return null;
      }
    };

    // use MRD number here
    // _checkout.wigroup.phoneNumber = _checkout.removeLeadingZero($scope._rc.cart.customer.phone_1);

    // used once instead of a recurring filter
    _checkout.formatPhoneNumber = function (phoneNum) {

      if (!phoneNum) { return ''; }
      phoneNum = String(phoneNum);
      phoneNum = _checkout.removeLeadingZero(phoneNum);

      var front = phoneNum.substring(0, 2),
          middle = phoneNum.substring(2, 5),
          end = phoneNum.substring(5, 9);

      return front + ' ' + middle + ' ' + end;
    };

    _checkout.validateUserNumber = function (loyaltyProgram) {

      _checkout.wigroup.loadingValid = true;
      _checkout.wigroup.valid = null;

      $http.post(window.env.apiURL + 'loyalty-programs/verification/', {
        'type': loyaltyProgram.type,
        'payload': {
          'program_id': loyaltyProgram.payload.program_id,
          'number': '0' + _checkout.wigroup.phoneNumber,
          'restaurant_id': JSON.stringify($scope._rc.cart.restaurant.id)
        }
      },
      { bypassErrorHandler: true })
      .then(function(res){
        console.log('success', res);
        _checkout.wigroup.loadingValid = false;
        _checkout.wigroup.valid = true;
      })
      .catch(function(res){
        _checkout.wigroup.loadingValid = false;
        _checkout.wigroup.valid = false;
        _checkout.wigroup.error = res.data.error;
      });
      console.log('validate!');
    };

    //#########################################################
    //  EBUCKS
    //#########################################################

    $scope.ebucksEarnShow = ebucksLoyalty && ebucksLoyalty.status !== 'hidden';
    _checkout.ebucksEarnEnabled =  ebucksLoyalty && ebucksLoyalty.status === 'active';
    _checkout.ebucksRsaId = $scope._rc.access.lastEbucksRsaId || '';
    _checkout.ebucksEarn = _checkout.ebucksRsaId? '1' : '0';
    _checkout.ebucksRsaIdLength = 0;
    _checkout.ebucksRsaIdReady = false;
    _checkout.ebucksRsaIdErrors = [];

    $scope.ebucksShowForgotPin = false;
    $scope.ebucksBurnMustLogin = false;
    _checkout.ebucksBusy = false;
    $scope.ebucksInfo = '';
    $scope.ebucksErr = '';
    _checkout.ebucksId = $scope._rc.access.lastEbucksId || '';
    _checkout.ebucksPin = '';
    $scope.ebucksAccounts = [];
    $scope.ebucksSelectedAccount = null;
    $scope.ebucksTotal = '';
    $scope.ebucksRequireOTP = false;
    _checkout.ebucksOTP = '';
    _checkout.ebucksCartPayment = null;

    $scope.ebucksCancel = function(e) {
      //if (e.target !== e.currentTarget) return;
      $scope.ebucksBurnMustLogin = false;
      $scope.ebucksInfo = '';
      $scope.ebucksErr = '';
      $scope.ebucksAccounts = [];
      $scope.ebucksSelectedAccount = null;
      $scope.ebucksTotal = '';
      $scope.ebucksRequireOTP = false;
      _checkout.ebucksOTP = '';
      _checkout.ebucksCartPayment = null;
      _checkout.isWorking = false;
    };

    $scope.activatedEbucksEarn = function(){
      if ($scope._rc.cart.payment.type === 'ebucks') {
        //this can no longer be the case after the change that hides ebuck earn for non-card payments
        $scope._rc.cart.payment.type = 'credit';
        _checkout.validatePaymentTypeSelection();
        _checkout.changePayment();
      }
    };

    $scope.onChangeRsaId = function() {
      _checkout.ebucksRsaIdLength = _checkout.ebucksRsaId? _checkout.ebucksRsaId.toString().length : 0;
      if (_checkout.ebucksRsaIdLength !== 13) {
        _checkout.ebucksRsaIdErrors = [];
        _checkout.ebucksRsaIdReady = false;
        return;
      }
      _checkout.ebucksRsaIdErrors = window.testRsaId(_checkout.ebucksRsaId);
      _checkout.ebucksRsaIdReady = _checkout.ebucksRsaIdErrors.length === 0;
    };
    if (_checkout.ebucksEarn === '1') $scope.onChangeRsaId();

    $scope.ebucksForgotPin = function() {
      $scope.ebucksShowForgotPin = !$scope.ebucksShowForgotPin;
    };
    $scope.ebucksLogin = function() {
      $scope.ebucksInfo = '';
      $scope.ebucksErr = '';
      var addFees = $scope._rc.checkForUndefined($scope._rc.cart.totals.all_additional_fees, 0);
      var foodDiscount = $scope._rc.checkForUndefined($scope._rc.cart.totals.food_discount, 0);
      var discount = $scope._rc.checkForUndefined($scope._rc.cart.totals.discount,0);
      var tip = $scope._rc.cart.delivery? $scope._rc.checkForUndefined($scope._rc.cart.delivery.driver_tip, 0) : 0;
      var dFee = $scope._rc.checkForUndefined($scope._rc.cart.totals.delivery_fee, 0);
      var total = $scope._rc.cart.totals.subtotal + addFees + foodDiscount + tip + dFee + discount;
      $scope.ebucksTotalRand = total;
      $scope.ebucksTotal = Math.round(total * 100) / 10;
      _checkout.ebucksBusy = true;
      ebucks.login(_checkout.ebucksId,_checkout.ebucksPin).then(function(accounts){
        //console.log('eBucks accounts', accounts);
        if (accounts && accounts.length) {
          $scope.ebucksSelectedAccount = null;
          for (var i=0; i<accounts.length; i++) {
            accounts[i].low = $scope.ebucksTotal > accounts[i].balance;
            accounts[i].selected = false;
            if (!$scope.ebucksSelectedAccount && !accounts[i].low) {
              accounts[i].selected = true; //select first valid account
              $scope.ebucksSelectedAccount = accounts[i];
            }
          }
        }
        $scope.ebucksAccounts = accounts;

        //store `_checkout.ebucksId` for pre-population
        $scope._rc.access.lastEbucksId = _checkout.ebucksId;
        storage.set('mrd-web-access', $scope._rc.access);
        _checkout.ebucksBusy = false;
      })
      .catch(function(er){
        $scope.ebucksErr = er&&er.friendly_message? er.friendly_message : er&&er.developer_message? er.developer_message : er&&er.message? er.message : er;
        _checkout.ebucksBusy = false;
      });
    };
    $scope.ebucksAccSelected = function(acc){
      $scope.ebucksAccounts.forEach(function(a){ a.selected = a===acc; });
      $scope.ebucksSelectedAccount = acc;
    };
    $scope.ebucksGetOTP = function() {
      $scope.ebucksInfo = '';
      $scope.ebucksErr = '';
      $scope.ebucksRequireOTP = true; //no going back
      var tip = $scope._rc.cart.delivery? $scope._rc.checkForUndefined($scope._rc.cart.delivery.driver_tip, 0) : 0;
      var donation = $scope._rc.cart.restaurant.donation || 0;
      ebucks.getOTP($scope._rc.cart.id, tip, donation).then(function(res){
        //var sentTo = res.destination;
        //console.log('eBucks otp request', res);
        $scope.ebucksInfo = 'We’ve sent a one time pin (OTP) for eB '+$scope.ebucksTotal+' to your number ****'+res.destination.substring(6)+'.';
      })
      .catch(function(er){
        if (er.sessionExpired) {
          $scope.ebucksCancel();
          $scope.ebucksBurnMustLogin = true;
          _checkout.isWorking = true;
        }
        $scope.ebucksErr = er&&er.friendly_message? er.friendly_message : er&&er.developer_message? er.developer_message : er&&er.message? er.message : er;
      });
    };
    $scope.ebucksOnChangeOTP = function(e) {
      if (_checkout.ebucksOTP.length < 6) return;
      $scope.ebucksInfo = '';
      $scope.ebucksErr = '';
      _checkout.ebucksBusy = true;
      ebucks.validateOTP(_checkout.ebucksOTP).then(function(res){
        //var sentTo = res.destination;
        //console.log('eBucks otp validation', res);

        $scope.ebucksInfo = 'Success! Continuing with the order.';
        var acc = $scope.ebucksAccounts.find(function(acc){ return acc.selected; });
        _checkout.ebucksCartPayment = {
          type: 'ebucks',
          account: {
            number: acc.number,
            session_token: ebucks.getSessionToken(),
            otp: _checkout.ebucksOTP
          }
        };
        $scope.ebucksBurnMustLogin = false;
        _checkout.initiatePayment();
      })
      .catch(function(er){
        if (er.sessionExpired) {
          $scope.ebucksCancel();
          $scope.ebucksBurnMustLogin = true;
          _checkout.isWorking = true;
        }
        $scope.ebucksErr = er&&er.friendly_message? er.friendly_message : er&&er.developer_message? er.developer_message : er&&er.message? er.message : er;
        _checkout.ebucksBusy = false;
      });
    };

    //#########################################################
    //  end of EBUCKS
    //#########################################################

    $scope.$on('cart:modified', function (event, input) {
      if (input !== 'Cleared' && input !== 'Emptied') return;
      var ad = $scope._rc.variables.address;
      if(ad.latitude && ad.longitude && ad.street_name){
        $state.go('location', {lat:ad.latitude, lng:ad.longitude, street_name:ad.street_name});
      } else {
        if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
      }
    });

    if (!$state.params.orderID) { // Somehow there is no order ID for this page... impossible.
      if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
    }

    if ($scope._rc.cart.fresh) { // If cart is new...

      order
        .$promise
        .then(function (order) {

          angular.extend($scope._rc.cart, order);

          delete $scope._rc.cart.fresh;
          delete $scope._rc.cart.items;

          $rootScope.$broadcast('cart:modified');
          storage.set('mrd-web-cart', $scope._rc.cart);
        });
    } else {
      // Cart is not fresh anymore, could potentially be confirmed, accepted or futher
      // down the process..
      order
        .$promise
        .then(function (order) {

          $scope._rc.cart.totals.food_discount = order.totals.food_discount;

          switch (order.status) {
            case 'delivered':
            case 'restaurant_accepted':
            case 'delivery_instruction_received':
            case 'en_route_to_collection':
            case 'at_restaurant':
            case 'en_route_to_delivery':
            case 'nearby':
            case 'doorbell':
            case 'delivered':
            case 'system_auto_rejected':
            case 'restaurant_auto_rejected':
            case 'restaurant_rejected':
            case 'cancelled':
            case 'failed_delivery_injection':
            case 'failed_restaurant_injection':
            case 'failed_delivery':
            case 'user_confirmed_payment':
            case 'awaiting_feedback':
              if($scope._rc.variables.address.latitude &&
                $scope._rc.variables.address.longitude &&
                $scope._rc.variables.address.street_name){
                $state.go('location', {
                  lat: $scope._rc.variables.address.latitude,
                  lng: $scope._rc.variables.address.longitude,
                  street_name: $scope._rc.variables.address.street_name
                });
              } else {
                if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
              }
              break;
          }
        });
    }

    if ($scope._rc.cart.delivery && $scope._rc.cart.type === 'delivery') {
      $scope._rc.cart.delivery.driver_tip = 0;
    }
    if ($scope._rc.cart.type === 'collect') {
      $scope._rc.cart.payment.type = 'credit'; // Collect order default to credit
    } else if (!$scope._rc.cart.payment.type) {
      $scope._rc.cart.payment.type = 'credit';
    }

    $scope._rc.cart.payment.refunded_to = 'wallet';

    $scope.paymeths = {};
    $scope.paymsgs = {};
    $scope.enabledLoyaltyPrograms = {};
    if ($scope._rc.cart.payment.payment_methods) {
      //console.log('LPs', _checkout.loyaltyPrograms);
      $scope._rc.cart.payment.payment_methods.forEach(function(meth){
        $scope.paymeths[meth.type] = meth.status;
        $scope.paymsgs[meth.type] = meth.message;
        $scope.enabledLoyaltyPrograms[meth.type] = _checkout.loyaltyPrograms
        .filter(function(lp) {
          if (lp.status !== 'active') return false;
          if (!lp.payload.payment_methods.hasOwnProperty(meth.type)) return true;
          if (lp.payload.payment_methods[meth.type].status === 'active') return true;
          return false;
        })
        .map(function(lp){
          return lp.type;
        });
        //console.log('LPs',meth.type, $scope.enabledLoyaltyPrograms[meth.type]);
      });
    }
    _checkout.validatePaymentTypeSelection = function(){
      //console.log("_checkout.loyaltyPrograms", _checkout.loyaltyPrograms);
      if ($scope._rc.cart.payment.type === 'credit' && $scope.paymeths.credit !== 'active') {
        $scope._rc.cart.payment.type = 'instant_eft';
      }
      if ($scope._rc.cart.payment.type === 'instant_eft' && $scope.paymeths.instant_eft !== 'active') {
        $scope._rc.cart.payment.type = 'cash';
      }
    };

    //#########################################################
    //  DELIVERY ADDRESS
    //#########################################################

    var address = $scope._rc.cart.customer.address;
    if ($scope._rc.access.user.saved_addresses) {
      address = $scope._rc.access.user.saved_addresses.find(function(a){
        return a.latitude === address.latitude && a.longitude === address.longitude;
      });
    } else {
      address = null;
    }
    if (address) {
      delete address.crud_info;
      $scope._rc.cart.customer.address = address;
    }

    //#########################################################
    //  CARD TOKENISATION
    //#########################################################

    _checkout.loadCards = function() {
      $scope._rc.cardsShow = false;
      $scope.cardsLoading = true;
      $scope._rc.loadCards($scope._rc.cart.payment.provider, $scope._rc.cart.payment.provider === 'payu')
      .then(function(cards){
        $scope.cards = cards;
        $scope.cardSelected = $scope.cards.find(function(c){
          return c.is_default&&!c.is_expired;
        });
        _checkout.checkReady();
        $scope.cardsLoading = false;
        $scope.hidePayuCancelButton = cards.length === 0;
      })
      .catch(function(er){
        console.warn('Unable to load saved cards.');
        $scope.cardsLoading = false;
      });
    };
    $scope.showCards = function (showPayuCardForm) {
      $scope.cardSelecting = true;
      if (showPayuCardForm) $scope._rc.showPayuCardForm = true;
    };
    $scope.selectCard = function(card) {
      if (card && card.is_expired) return;
      $scope.cardSelected = card;
      _checkout.checkReady();
      $scope.cardSelecting = false;
    };
    $scope.cardsEdit = function(){
      if ($scope.cardEditing) {
        $scope.cardEditing = false;
        $scope.cardEditingText = 'edit';
      } else {
        $scope.cardEditing = true;
        $scope.cardEditingText = 'done';
      }
    };
    $scope.deleteCard = function(e,card) {
      e.preventDefault();
      e.stopPropagation();
      if (card.isDeleting) return;
      card.isDeleting = true;
      $http.delete(window.env.apiURL + 'v3/users/'+$scope._rc.access.user.id+'/saved_cards/'+card._uuid, {bypassErrorHandler:true})
      .then(function(result){
        if ($scope.cardSelected && $scope.cardSelected._uuid === card._uuid) $scope.cardSelected = null;
        // $scope.cards = $scope.cards.filter(function(c){
        //   return c._uuid !== card._uuid;
        // });
        card.isDeleted = true; //css delete animation
      })
      .catch(function(er){
        console.warn('Unable to delete card', card.n);
        card.isDeleting = false;
      });
    };
    $scope.cardSelected = null;
    $scope.cards = [];
    _checkout.loadCards();
    $scope.cardEditingText = 'edit';

    //#########################################################
    //  Statuses
    //#########################################################


    _checkout.checkReady = function () {
      if ($scope._rc.cart.payment.type === 'ebucks') {
        $scope.ebucksEarn = '0';
      }
      if ($scope._rc.cart.payment.type === 'cash' && ($scope._rc.cart.totals.subtotal + $scope._rc.cart.totals.delivery_fee) > 2000) {
        _checkout.ready = false;
        _checkout.ready_reason = 'The maximum order amount for \'Cash on Delivery\' is R2000,00.';
      } else if ($scope._rc.cart.payment.type === 'credit' && $scope.paymeths.credit === 'hidden') {
				$scope._rc.cart.payment.type = 'instant_eft';
			} else if (
				(
					$scope._rc.cart.totals.subtotal +
					$scope._rc.checkForUndefined($scope._rc.cart.totals.all_additional_fees,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.totals.food_discount,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.delivery ? $scope._rc.cart.delivery.driver_tip : 0,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.restaurant.donation,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.totals.delivery_fee,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.totals.discount,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.refund_credit_applied,0) +
					$scope._rc.checkForUndefined($scope._rc.cart.totals.wicode_value_applied,0)
				) <= $scope._rc.cart.payment.refund_credit_available
			) {
				_checkout.ready = true;
        _checkout.ready_reason = '';
      } else if ($scope._rc.cart.payment.type === 'credit' && !$scope.cardSelected && $scope._rc.cart.payment.provider === 'payu') {
        _checkout.ready = false;
        _checkout.ready_reason = 'No card selected.';
      } else if ($scope.cardSelected && $scope.cardSelected.status === 'invalid') {
        _checkout.ready = false;
        _checkout.ready_reason = 'Please update your card.';
      } else {
        _checkout.ready = true;
        _checkout.ready_reason = '';
      }
    };
    _checkout.checkReady();

    _checkout.calcRefundCreditApplied = function() {
      // console.log('calcRefundCreditApplied');
      // profile credit needs to cover the total up until it can't.
      var _rc = $scope._rc;
			var cartTotalBeforeCredit =
				_rc.cart.totals.subtotal +
				_rc.checkForUndefined(_rc.cart.totals.all_additional_fees, 0) +
				_rc.checkForUndefined(_rc.cart.delivery ? _rc.cart.delivery.driver_tip : 0, 0) +
				_rc.checkForUndefined(_rc.cart.restaurant.donation, 0) +
				_rc.checkForUndefined(_rc.cart.totals.delivery_fee, 0);
			
      if ($scope._rc.cart.payment.refund_credit_available) {
        $scope._rc.cart.refund_credit_applied =  -Math.min(cartTotalBeforeCredit, $scope._rc.cart.payment.refund_credit_available);
      } else {
        $scope._rc.cart.refund_credit_applied = 0;
      }

    };

    _checkout.calcRefundCreditApplied();

    _checkout.calcDriverTip = function () {
      if ($scope._rc.cart.delivery) {
        if ($scope._rc.cart.payment.type !== 'cash') {
          $scope._rc.cart.delivery.driver_tip = Math.round($scope._rc.cart.totals.subtotal * $scope._rc.variables.tip_percentage) / 100;
          // $scope._rc.cart.totals.driver_tip = $scope._rc.cart.totals.subtotal * $scope._rc.variables.tip_percentage / 100;
          _checkout.calcRefundCreditApplied();
        } else {
          $scope._rc.cart.delivery.driver_tip = 0;
        }
      }
      _checkout.applyWiCode().then(function(res){

        //Save drive tip_percentage
        storage.set('mrd-web-variables', $scope._rc.variables);
        // Recalculate the amount of credit applied
        //_checkout.calcRefundCreditApplied();
      });

    };

    $scope.tipSelecting = false;
    _checkout.tipMoreOptions = [30,35,40,50];
    _checkout.tipMore = function(){
      $scope.tipSelecting = true;
      if ($scope._rc.variables.tip_percentage < 30) {
        $scope._rc.variables.tip_percentage = 30;
        _checkout.calcDriverTip();
      }
    };
    _checkout.tipMoreSave = function(){
      $scope.tipSelecting = false;
    };

    _checkout.changeBuildingType = function (value) {
      $scope._rc.cart.customer.address.building_type = value;


    };

    _checkout.changePayment = function () {
      _checkout.changePaymentLabel();
      _checkout.checkReady();
      _checkout.evaluateLoyaltyPrograms();
    };

    _checkout.changePaymentLabel = function () {
      //console.log($scope._rc.cart.payment.type)
      if ($scope._rc.cart.payment.type === 'credit') {
        _checkout.credit_eft_cash_label = 'Continue to Payment';
      }
      if ($scope._rc.cart.payment.type === 'instant_eft') {
        _checkout.credit_eft_cash_label = 'Continue to EFT Payment';
      }
      if ($scope._rc.cart.payment.type === 'cash') {
        _checkout.credit_eft_cash_label = 'Continue Cash Order';
      }
      if ($scope._rc.cart.payment.type === 'ebucks') {
        _checkout.credit_eft_cash_label = 'Pay with eBucks';
      }
    };

    _checkout.evaluateLoyaltyPrograms = function() {
      var ignoreEbucks = false;
      var enabledLPs = [];
      if ($scope.enabledLoyaltyPrograms.hasOwnProperty($scope._rc.cart.payment.type)) {
        enabledLPs = $scope.enabledLoyaltyPrograms[$scope._rc.cart.payment.type];
        //console.log('LP', $scope._rc.cart.payment.type, enabledLPs);
      }

      // if ($scope._rc.cart.payment.type === 'credit') {
      //   //show ebuck earn if other criteria is met
      //   _checkout.ebucksEarn = _checkout.ebucksRsaId? '1' : '0';
      // } else {
      //   //hide ebucks earn
      //   ignoreEbucks = true;
      // }
      // if (_checkout.ebucksEarn === '1') $scope.onChangeRsaId();



      var loyaltyPrograms = $scope._rc.variables.restaurant.loyalty_programs;
      loyaltyPrograms = loyaltyPrograms.filter(function(lp){

        if (lp.type === 'wigroup' && lp.status === 'active') {
          _checkout.wigroup_active = true;
        }
        //if (lp.type === 'ebucks' && ignoreEbucks) return false;
        return enabledLPs.indexOf(lp.type) >= 0;
        //return ~handledLoyaltyPrograms.indexOf(lp.type) && lp.status !== 'hidden';
      });
      _checkout.showLoyaltyPrograms = loyaltyPrograms.length > 0;
      var ebucksLoyalty = loyaltyPrograms.find(function(lp){ return lp.type==='ebucks';});
      $scope.ebucksEarnShow = ebucksLoyalty && ebucksLoyalty.status !== 'hidden';
      if ($scope.ebucksEarnShow) _checkout.ebucksEarn = _checkout.ebucksRsaId? '1' : '0';
      if (_checkout.ebucksEarn === '1') $scope.onChangeRsaId();
    };

    _checkout.setupSavedAddresses = function () {
      // console.log($filter('filter')($scope._rc.access.user.saved_addresses, {label:
      // 'home'} )); If user has selected a saved address. (Does not get preserved)
      if (!$scope._rc.cart.customer.address.label) {
        var home = $filter('filter')($scope._rc.access.user.saved_addresses, {label: 'home'});
        var work = $filter('filter')($scope._rc.access.user.saved_addresses, {label: 'work'});
        var other = $filter('filter')($scope._rc.access.user.saved_addresses, {label: 'other'});

        if (home && home.length > 0) {
          $scope._rc.cart.customer.address.label = 'work';
        }
        if (work && work.length > 0) {
          $scope._rc.cart.customer.address.label = 'other';
        }
        if (other && other.length > 0) {
          $scope._rc.cart.customer.address.label = ''; //needs to be deleted when posted to server
        }
      } else {
        //console.log('not label');
      }

    };

    _checkout.placeholderComplex = function () {
      if ($scope._rc.cart.customer.address.building_type === 'apartment') {
        return 'Unit no & complex name';
      }
      if ($scope._rc.cart.customer.address.building_type === 'office') {
        return 'Floor no & building name';
      }
      if ($scope._rc.cart.customer.address.building_type === 'complex / estate') {
        return 'Complex/estate name & house details';
      }
      if ($scope._rc.cart.customer.address.building_type === 'house') {
        return '';
      }
      if ($scope._rc.cart.customer.address.building_type === 'hotel / bed and breakfast') {
        return 'Room no & hotel name';
      }
    };

    function getSavedAddress(delay){
      return new Promise(function(resolve/*,reject*/){
        setTimeout(function() {
          userFactory
          .get({
            userID: $scope._rc.access.user.id
          }, function (succ) {
            delete succ.$promise;
            delete succ.$resolved;

            if ($scope._rc.access.user.saved_addresses) {
              angular.merge($scope._rc.access.user.saved_addresses, succ.saved_addresses);
            } else {
              $scope._rc.access.user.saved_addresses = succ.saved_addresses;
            }
            storage.set('mrd-web-access', $scope._rc.access);
            console.log('Address updated!');
            resolve();
          }, function (err) {
            console.log('Address could NOT update:', err);
            resolve(); //in case of a fail, do not stop the process
          });
        }, delay);
      });
    }

    _checkout.cancelOTP = function(){
      delete $scope.otp;
      _checkout.couponLoading = false;
    };

    _checkout.submitOTP = function(isOTPResend){
      if ($scope.otp) {

        if (isOTPResend){
          _checkout.isWorkingOTP = true;
        } else {
          _checkout.isWorking = true;
        }

        if ($scope.otp.requredBy === 'promo') {
          _checkout.applyPromoCode();
        } else {
          _checkout.initiatePayment();
        }
      }
    };

    _checkout.initiatePayment = function () {
      $scope._rc.track('checkout','tap_continue_to_payment'); //BUTTON CLICK

      _checkout.firebaseEvent('tap_continue_to_payment', {
        wicode: $scope.voucher.value || false,
        promo_code: $scope.coupon.value || false,
        wicode_value: $scope._rc.cart.totals.wicode_value_applied || false,
        promo_code_value: $scope._rc.cart.totals.discount || false,
        kauai_loyalty_type: _checkout.wigroup.earn, //TODO: wigroup program should go here. Eg. kauai, wimpy, etc.
        ebucks_loyalty_type: _checkout.ebucksEarn
      });

      _checkout.isWorking = true;

      var extraEbucksCartProps = {};
      var cartLoyaltyPrograms = [];

      // Setup
      if ($scope._rc.cart.status === 'initiated' || $scope._rc.cart.status === 'user_confirmed_details') { // Retest with user_confirmed_details
        $scope._rc.cart.status = 'user_confirmed_details';
        var host = window.location.protocol + '//' + window.location.host;
        if ($scope._rc.cart.payment.type === 'instant_eft') { // Need to add a GET infront of it.
          $scope._rc.cart.payment.client_callback_url = 'GET ' + host + '/order/payment/' + $scope._rc.cart.id + '/' + $scope._rc.access.user.id + '/';
        } else {
          $scope._rc.cart.payment.client_callback_url = host + '/order/payment/' + $scope._rc.cart.id + '/' + $scope._rc.access.user.id + '/';
        }
        if ($scope._rc.cart.payment.type === 'credit') {
          // $scope._rc.cart.payment.provider = 'paygate';
          if ($scope.cardSelected) {
            //console.log('Card', $scope.cardSelected);
            $scope._rc.cart.payment.saved_card_uuid = $scope.cardSelected._uuid;
          } else {
            //delete $scope._rc.cart.payment.saved_card_uuid;
            $scope._rc.cart.payment.saved_card_uuid = 'NEW_CARD';
          }
        } else {
          //console.log('Card payment type', $scope._rc.cart.payment.type );
          delete $scope._rc.cart.payment.saved_card_uuid;
        }

        // loyalty
        if (_checkout.wigroup.earn) {

          if (_checkout.wigroup.valid) {
            $scope._rc.access.lastWigroupNumber = _checkout.wigroup.phoneNumber;
          }

          cartLoyaltyPrograms.push({
            kauai: {
              number: '0' + _checkout.wigroup.phoneNumber
            }
          });
        } else {
          delete $scope._rc.access.lastWigroupNumber;
        }

        //EBUCKS
        if ($scope._rc.cart.payment.type === 'ebucks') {
          if (!_checkout.ebucksCartPayment) {
            $scope.ebucksBurnMustLogin = true;
            return;
          } else {
            extraEbucksCartProps.payment = _checkout.ebucksCartPayment;
          }
        } else if (_checkout.ebucksEarn === '1') {
          if (_checkout.ebucksRsaIdReady) {
            cartLoyaltyPrograms.push({'ebucks':{rsa_id_number:_checkout.ebucksRsaId.toString()}});

            //store `_checkout.ebucksRsaId` for pre-population
            $scope._rc.access.lastEbucksRsaId = _checkout.ebucksRsaId;
            storage.set('mrd-web-access', $scope._rc.access);
          } else {
            return; //earn ebucks not ready
          }
        }

      } else {
        //console.log('Card order status', $scope._rc.cart.status);
      }
      var tempFresh = $scope._rc.cart.fresh;

      var cart_to_send_up = {};
      cart_to_send_up.status = 'user_confirmed_details';
      cart_to_send_up.customer = $scope._rc.cart.customer;
      cart_to_send_up.customer.address = {
        // latitude: $scope._rc.cart.customer.address.latitude, // set on order init
        // longitude: $scope._rc.cart.customer.address.longitude, // set on order init
        street_number: $scope._rc.cart.customer.address.street_number,
        // street_name: $scope._rc.cart.customer.address.street_name, // set on order init
        // suburb: $scope._rc.cart.customer.address.suburb, // set on order init
        // // town: $scope._rc.cart.customer.address.town,
        // province: $scope._rc.cart.customer.address.province, // set on order init
        // postal_code: $scope._rc.cart.customer.address.postal_code, // set on order init
        label: $scope._rc.cart.customer.address.label, // note: modified below
        building_type: $scope._rc.cart.customer.address.building_type,
        complex: $scope._rc.cart.customer.address.complex,
      };
      if (!cart_to_send_up.customer.address.label) {
        delete cart_to_send_up.customer.address.label;
      }

      cart_to_send_up.restaurant = {};
      cart_to_send_up.restaurant.id = $scope._rc.cart.restaurant.id;
      cart_to_send_up.restaurant.order_notes = $scope._rc.cart.restaurant.order_notes;
      cart_to_send_up.restaurant.active_menu_deal = $scope._rc.cart.restaurant.active_menu_deal;
      cart_to_send_up.restaurant.active_buy_1_get_1_free = $scope._rc.cart.restaurant.active_buy_1_get_1_free;
      cart_to_send_up.restaurant.actual_distance = $scope._rc.cart.restaurant.actual_distance;
      cart_to_send_up.restaurant.donation = $scope._rc.cart.restaurant.donation;
      cart_to_send_up.restaurant.instructions = $scope._rc.cart.restaurant.instructions;

      cart_to_send_up.payment = {};
      cart_to_send_up.payment.type = $scope._rc.cart.payment.type;
      cart_to_send_up.payment.payment_methods = $scope._rc.cart.payment.payment_methods;
      cart_to_send_up.payment.refunded_to = $scope._rc.cart.payment.refunded_to;
      cart_to_send_up.payment.saved_card_uuid = $scope._rc.cart.payment.saved_card_uuid;
      cart_to_send_up.payment.provider = $scope._rc.cart.payment.provider;
      cart_to_send_up.payment.account = $scope._rc.cart.payment.account;
      cart_to_send_up.payment.client_callback_url = $scope._rc.cart.payment.client_callback_url;

      cart_to_send_up.delivery = {};
      if ($scope._rc.cart.delivery) {
        cart_to_send_up.delivery.driver_tip = $scope._rc.cart.delivery.driver_tip;
      }

      if (extraEbucksCartProps.payment) {
        Object.assign(cart_to_send_up.payment, extraEbucksCartProps.payment);
      }
      cart_to_send_up.loyalty_programs = $scope._rc.cart.loyalty_programs;
      if (cartLoyaltyPrograms.length) {
        cart_to_send_up.loyalty_programs = cartLoyaltyPrograms;
      }

      if ($scope.otp) {
        $scope.otp.invalid = false;
        cart_to_send_up.verification = {
          token: ''+$scope.otp.value
        };
      } else {
        delete cart_to_send_up.verification;
      }

      orderFactory.update({
        'userID': $scope._rc.access.user.id,
        'orderID': $scope._rc.cart.id
      }, cart_to_send_up, function success(response) {

        delete response.$promise;
        delete response.$resolved;
        delete response.verification;
        angular.extend($scope._rc.cart, response);
        if (response.menu && response.menu.id) {
          $scope._rc.cart.restaurant.menu_id = response.menu.id;
        }

        $rootScope.$broadcast('cart:modified');
        storage.set('mrd-web-cart', $scope._rc.cart);

        if ($scope._rc.cart.payment.type === 'credit' || $scope._rc.cart.payment.type === 'instant_eft') {
          _checkout.credit_eft_cash_label = 'Redirecting...';
        }

        var continueCheckout = function(){
          if ($scope._rc.cart.payment.type === 'credit' || $scope._rc.cart.payment.type === 'instant_eft') {
            if ($scope._rc.cart.payment.gateway_token_url) {
              $window.location.href = $scope._rc.cart.payment.gateway_token_url;
            } else {
              console.warn('Payment URL is empty.', $scope._rc.cart.payment.gateway_token_url);
              _checkout.isWorking = false;
              _checkout.changePaymentLabel();
              _checkout.checkReady();
              $rootScope.$broadcast('global_message:show',{
                'name': 'login_issue',
                'for_state': 'checkout',
                'title': 'Unable to process payment',
                'error' : {
                  'friendly_message': 'Payment could not be initated. Please try again.'
                },
                'confirm' : false,
                'deny' : {
                  'label': 'Okay, got it!',
                  'action': 'close',
                  'value': true,
                  'value_object': null
                }
              });
            }
          } else if (
            $scope._rc.cart.payment.type === 'ebucks' ||
            $scope._rc.cart.payment.type === 'wallet' ||
            $scope._rc.cart.payment.type === 'wicode' ||
            $scope._rc.cart.payment.status === 'paid'
          ) {
            _checkout.isWorking = false;
            $state.go('payment_return', {
              orderID: $scope._rc.cart.id,
              userID: $scope._rc.access.user.id,
              statusID: 'cash'
            });
          } else {
            _checkout.isWorking = false;
            $state.go('payment_confirm', {
              orderID: $scope._rc.cart.id,
              userID: $scope._rc.access.user.id,
              statusID: 'cash'
            });
          }
        };
        if ($scope._rc.cart.customer.address.label) {
          getSavedAddress(2000).then(continueCheckout);
        } else {
          continueCheckout();
        }

      }, function err(response) {
        _checkout.isWorking = false;
        _checkout.isWorkingOTP = false;

        console.log('ORDER FAILED', response);

        if (response.status === 441) { //OTP required
          $scope.otp = {
            title: response.data.error.developer_message,
            message: response.data.error.friendly_message,
            cooldown: true,
            value: ''
          };
          $timeout(function(){
            if ($scope.otp) $scope.otp.cooldown = false;
          }, 15000);
          return;
        } else if (response.data.error.error_code === 'INVALID_OTP_TOKEN') { //invalid OTP
          $scope.otp.invalid = true;
          $scope.otp.value = '';
          return;
        } else {
          delete $scope.otp;
        }

        // SENTRY
        try {
          var er = response.data.error;
          if (er) {
            console.warn('Cart Payment.', er.developer_message, er.error_code);
            if ((er.error_code === 'VALIDATION_ERRORS') && er.friendly_message) console.warn(er.friendly_message);
            window.Raven.captureMessage('Cart Payment.', Object.assign({level:'warning'},er.developer_message));
          }
        } catch (error) {
          console.warn('Could not report error.', error);
        }

        // POPUP
        var message = 'error';
        if (response.data.error.friendly_message) {
          message = response.data.error.friendly_message;
        } else if (response.data.error.developer_message === 'invalid status') {
          message = 'Invalid Status';
        }

        $rootScope.$broadcast('global_message:show',{
          'name': 'login_issue',
          'for_state': 'checkout',
          'title': 'We detected a problem.',
          'error' : {
            'friendly_message': message
          },
          'confirm' : false,
          'deny' : {
            'label': 'Okay, got it!',
            'action': 'close',
            'value': true,
            'value_object': null
          }
        });
      });
      $scope._rc.cart.fresh = tempFresh; // GRRRrr hack to not send up fresh field...
    };

    $scope.openDiscountCodes = function(skipOpen){
      $scope.coupon.success = false;
      $scope.coupon.error = false;
      $scope.voucher.success = false;
      $scope.coupon.error = false;
      if ($scope._rc.cart.discounts) {
        var discounts = $scope._rc.cart.discounts;
        if (discounts.coupon && discounts.coupon.code) {
          $scope.coupon.value = discounts.coupon.code;
          $scope.coupon.success = true;
          $scope.coupon.error = false;
        }
        if (discounts.wicode && discounts.wicode.code) {
          $scope.voucher.value = discounts.wicode.code;
          $scope.voucher.success = true;
          $scope.coupon.error = false;
        }
      }
      if (!skipOpen) {
        $scope.showDiscountCodes = true;
        _checkout.firebaseEvent('view_apply_code_screen', {});
      }

    };
    _checkout.closeDiscountCodes = function(){
      if ($scope.coupon.error) {
        //$scope.voucher.value = null;
        if ($scope._rc.cart.discounts && $scope._rc.cart.discounts.wicode) {
          delete $scope._rc.cart.discounts.wicode;
        }

      }
      $scope.showDiscountCodes = false;
    };

    $scope.openDiscountCodes(true);


    _checkout.applyPromoCode = function(){

      $scope.coupon.error = false;

      if ($scope.coupon.value) {
        var coupon_req = {
          discounts: {
            coupon: {
              code: $scope.coupon.value
            }
          }
        };

        if ($scope.otp) {
          $scope.otp.invalid = false;
          coupon_req.discounts.verification_token = ''+$scope.otp.value;
        } else {
          delete coupon_req.discounts.verification_token;
        }

        $scope.coupon.busy = true;
        $http.put(window.env.apiURL + 'v3/users/'+$scope._rc.access.user.id+'/orders/'+$scope._rc.cart.id, coupon_req, {bypassErrorHandler:true})
        .then(function(res){
          delete $scope.otp;

          // _checkout.payu = res.payment.provider === 'payu'; // otherwise paygate // GW: Dan this is causing the `.catch()` below to execute. As is `payu` will never be set to `true` because `res.payment` is always undefined. Even after I changed it to `res.data.payment` it would fail due to `res.data.payment` being undefined. I realise we need to know which pay provider is used, but I'm not sure how you wanted it to be determined. I've commented it out for now.
          _checkout.isWorking = false;
          _checkout.isWorkingOTP = false;
          $scope.coupon.busy = false;
          $scope.coupon.error = false;
          _checkout.couponErrorMessage = '';
          $scope.coupon.success = true;
          $scope.coupon.error = false;

          _checkout.firebaseEvent('tap_apply_promo_code', {
            response_code: res.status,
            promo_code: res.data.discounts.coupon.code,
            response_message: 'successful'
          });

          delete res.data.discounts.verification_token;
          angular.merge($scope._rc.cart, res.data);

          _checkout.calcRefundCreditApplied(); //recalculate any credit deduction

          $rootScope.$broadcast('cart:modified');
          storage.set('mrd-web-cart', $scope._rc.cart);
        })
        .catch(function(res){
          console.log('err', res);

          _checkout.isWorking = false;
          _checkout.isWorkingOTP = false;

          if (res.status === 441) {
            $scope.otp = {
              title: res.data.error.developer_message,
              message: res.data.error.friendly_message,
              cooldown: true,
              value: '',
              requredBy: 'promo'
            };
            $timeout(function(){
              if ($scope.otp) $scope.otp.cooldown = false;
            }, 15000);
            return;
          } else if (res.data && res.data.error && res.data.error.error_code === 'INVALID_USAGE') { //invalid OTP
            if ($scope.otp) {
              $scope.otp.invalid = true;
              $scope.otp.value = '';
              return;
            }
          } else {
            delete $scope.otp;
          }
          $scope.coupon.busy = false;
          $scope.coupon.error = true;
          $scope.coupon.success = false;

          if (res.data && res.data.error && res.data.error.developer_message) {
            _checkout.couponErrorMessage = res.data.error.developer_message;
          }

          _checkout.firebaseEvent('tap_apply_promo_code', {
            response_code: res.status,
            promo_code: $scope.coupon.value,
            response_message: res.data.error.friendly_message
          });

        });

      }
    };

    _checkout.applyWiCode = function(){

      $scope.voucher.error = false;

      if ($scope.voucher.value) {
        var tip = $scope._rc.cart.delivery? $scope._rc.checkForUndefined($scope._rc.cart.delivery.driver_tip, 0) : 0;
        var donation = $scope._rc.cart.restaurant.donation || 0;
        var coupon_req = {
          discounts: {
            wicode: {
              code: $scope.voucher.value
            }
          },
          delivery:{
            driver_tip: tip
          },
          restaurant: {
            donation: donation
          }
        };

        $scope.voucher.busy = true;
        return $http.put(window.env.apiURL + 'v3/users/'+$scope._rc.access.user.id+'/orders/'+$scope._rc.cart.id, coupon_req, {bypassErrorHandler:false})
        .then(function(res){

          _checkout.isWorking = false;
          $scope.voucher.busy = false;
          $scope.voucher.error = false;
          $scope.voucher.success = true;

          if (res.data.payment.status !== 'paid') {
            // payment type always comes back as 'wicode', but if the bill is not settled this is changed back to the user chosen method
            res.data.payment.type = $scope._rc.cart.payment.type;
          }
          angular.merge($scope._rc.cart, res.data);
          console.log('applied wicode. payment update', $scope._rc.cart.payment);

          _checkout.calcRefundCreditApplied(); //recalculate any credit deduction

          $rootScope.$broadcast('cart:modified');
          storage.set('mrd-web-cart', $scope._rc.cart);

          _checkout.firebaseEvent('tap_apply_wicode', {
            response_code: res.status,
            wicode: res.data.discounts.wicode.code,
            response_message: 'successful'
          });

        })
        .catch(function(res){
          console.log('voucher err', res);

          $scope.voucher.friendly_message = res.data.error.friendly_message;

          _checkout.isWorking = false;
          _checkout.isWorkingOTP = false;
          $scope._rc.cart.totals.wicode_value_applied = 0;
          $scope.voucher.busy = false;
          $scope.voucher.success = false;
          $scope.voucher.error = true;

          _checkout.firebaseEvent('tap_apply_wicode', {
            response_code: res.status,
            wicode: $scope.voucher.value,
            response_message: $scope.voucher.friendly_message
          });
          if ($scope._rc.cart.discounts && $scope._rc.cart.discounts.wicode) {
            delete $scope._rc.cart.discounts.wicode;
          }
          storage.set('mrd-web-cart', $scope._rc.cart);
          $scope._rc.cart.payment.type = 'credit';

          if (!$scope.showDiscountCodes){
            _checkout.showWiErr = res.data.error;
            _checkout.showWiErr.developer_messages = res.data.error.developer_message.split('\n');
          }
        });

      }

      return Promise.resolve(true);
    };

    _checkout.calcDriverTip();

    // Init
    if (_checkout.ebucksEarn) {
      $scope.activatedEbucksEarn();
    } else {
      _checkout.validatePaymentTypeSelection();
      _checkout.changePaymentLabel();
    }


    _checkout.building_type = [
      {
        id: 'complex / estate',
        label: 'Complex/Estate'
      }, {
        id: 'apartment',
        label: 'Apartment'
      }, {
        id: 'house',
        label: 'House'
      }, {
        id: 'office',
        label: 'Office'
      }, {
        id: 'hotel / bed and breakfast',
        label: 'Hotel / B&B'
      }
    ];

    _checkout.setRestaurantDonation = function() {
      $scope._rc.cart.restaurant.donation = parseInt($scope._rc.variables.restaurant_donation);
      storage.set('mrd-web-variables', $scope._rc.variables);
      storage.set('mrd-web-cart', $scope._rc.cart);
      _checkout.calcRefundCreditApplied(); // refund needs to cover the dondation.
    };

  });
